import React from 'react';
import './index.scss';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';

const language = {
  en: 'en',
  vi: 'vi',
};
class Notifications extends React.Component {
  render() {
    const {
      data: { controlStatusCode, controlStatusName },
      i18n,
    } = this.props;

    return (
      <div className="notifications-wrapper">
        {controlStatusCode && controlStatusCode !== -1 && (
          <>
            <div className="box">
              <Translate value="common.watchOut.title" />
            </div>
            <div className="notice-content">
              <div className="d-flex">
                {<Translate value={`common.watchOut.description`} />}{' '}
                <div className="important-content ml-2">
                  {i18n.locale === language.vi ? ` Nhóm ` : ''}
                  {`${controlStatusName}`}
                  {i18n.locale === language.en ? ` Group ` : ''}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
  };
};

Notifications.defaultProps = {
  data: {
    controlStatusCode: -1,
    controlStatusName: 'Group_Name',
  },
};

export default connect(mapStateToProps)(Notifications);
